module.exports = __webpack_public_path__ + "static/img/hw3z.f7124b6f.png";